import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import PaymentDesktopHeader from "./PaymentDesktopHeader";
import PassengerMobileHeader from "./PassengerMobileHeader";


type Props = {
  navigateHandler?: () => void
}
function PaymentHeaderNavigation({ navigateHandler }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };

  return (
      isMobile ? (
          <PassengerMobileHeader navigateHandler={handleNavigate} />
      ) : (
          <PaymentDesktopHeader navigateHandler={handleNavigate} />
      )
  )
}

PaymentHeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default PaymentHeaderNavigation;
